module.exports = window["Bernie_l10nBundle_ru_RU"];